// extracted by mini-css-extract-plugin
export default {"veil":"veil_veil__VIVcK","veilShow":"veil_veil-show__I9Mo7","veilOpen":"veil_veil-open__ifVAI"};